import { FC } from 'react'
import PerIcon from '../Icon'
import './index.less'

export interface EmojiRatingProps {
  currentlySelected?: number
  onEmojiClicked: (id: number) => void
  disabled: boolean
}

const EmojiRating: FC<EmojiRatingProps> = ({ currentlySelected, onEmojiClicked, disabled }) => {
  return (
    <div className={`emoji-ratings ${disabled ? ' emoji-ratings_disabled' : ''}`}>
      <div
        data-e2e-emoji="sad"
        className={currentlySelected === 0 ? 'emoji-ratings--red' : 'emoji-ratings--off'}
        onClick={() => onEmojiClicked(0)}
      >
        <PerIcon name="smileySad_fill" />
      </div>
      <div
        data-e2e-emoji="unhappy"
        className={currentlySelected === 1 ? 'emoji-ratings--orange' : 'emoji-ratings--off'}
        onClick={() => onEmojiClicked(1)}
      >
        <PerIcon name="smileyUnhappy_fill" />
      </div>

      <div
        data-e2e-emoji="indifferent"
        className={currentlySelected === 2 ? 'emoji-ratings--yellow' : 'emoji-ratings--off'}
        onClick={() => onEmojiClicked(2)}
      >
        <PerIcon name="smileyIndifferent_fill" />
      </div>
      <div
        data-e2e-emoji="smirk"
        className={currentlySelected === 3 ? 'emoji-ratings--mint' : 'emoji-ratings--off'}
        onClick={() => onEmojiClicked(3)}
      >
        <PerIcon name="smileySmirk_fill" />
      </div>
      <div
        data-e2e-emoji="happy"
        className={currentlySelected === 4 ? 'emoji-ratings--green' : 'emoji-ratings--off'}
        onClick={() => onEmojiClicked(4)}
      >
        <PerIcon name="smileyHappy_fill" />
      </div>
    </div>
  )
}

export default EmojiRating
